import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import back from "../../assets/images/svg/back.svg";
import profile from "../../assets/images/svg/avatar.svg";
import email from "../../assets/images/svg/email.svg";
import call from "../../assets/images/svg/call.svg";
import edit from "../../assets/images/svg/edit.svg";
import map from "../../assets/images/svg/location.svg";
import DriverDetailCard from "../../components/cards/DriverDetailCard";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import add from "../../assets/images/svg/add.svg";
import reject from "../../assets/images/svg/reject.svg";
import minus from "../../assets/images/svg/minus.svg";
import returnIcon from "../../assets/images/svg/return.svg";
import dotIcon from "../../assets/images/svg/dot.svg";
import reload from "../../assets/images/svg/reload.svg";
import MapComponent from "../../components/maps/MapComponent";
import CustomPagination from "../../components/CustomPagination";
import { usePagination } from "../../hooks";
import DynamicTable from "../../components/DynamicTable";
import { $crud } from "../../utils/CrudFactory";
import sort from "../../assets/images/svg/sort.svg";
import { BASE_URL } from "../../constants";
import {
  formatMoney,
  formatter,
  timeOnline,
  toLocalTime,
} from "../../helper/functions";
import DriverEditModal from "../../components/modals/DriverEditModal";
import InsuranceDetailsModal from "../../components/modals/InsuranceDetailsModal";
import dayjs from "dayjs";
import { socket } from "../../components/notification/Notifications";
import { enqueueSnackbar } from "notistack";

const statusIcon = {
  Active: reload,
  Blocked: reject,
  "Enrollment Review": minus,
  "Pending Enrollment": minus,
};

const getStatusStyles = (status) => {
  switch (status) {
    case "Booked":
      return {
        background: "#1ACA6D !important",
        color: "#ffffff",
      };
    case "Processing":
      return {
        background: "#FB970B !important",
        color: "#ffffff",
      };
    case "Delivered":
      return {
        background: "#074F24 !important",
        color: "#ffffff",
      };
    default:
      return {
        background: "#FFF0ED !important",
        color: "rgba(254, 133, 106, 1)",
      };
  }
};

// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------

const CustomStepConnector = () => (
  <StepConnector
    sx={{
      "& .MuiStepConnector-line": {
        border: "1px dashed rgba(103, 60, 142, 1)",
      },
    }}
  />
);

// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------

// CUSTOM TOOLTIP ====================================
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: 140, // Custom maxWidth for Tooltip
    minHeight: 56, // Custom maxWidth for Tooltip
    background: "#795898", // Additional styles if needed
    color: "#fff", // Additional styles if needed
    fontSize: "8px", // Additional styles if needed
    padding: "8px", // Additional styles if needed
    position: "absolute",
    top: "-38px",
    left: "-90px",
    borderRadius: "0",
  },
});

// STEPS FOR THE STATUS OF ORDER -------------------------------

const steps = [];

// STEPS FOR THE STATUS OF ORDER -------------------------------
export default function DriverDetail() {
  const [orders, setOrders] = React.useState([
    // {
    //   id: 1,
    //   pickups: 4,
    //   kms: 144,
    //   weight: "124 Lbs / 20 Kgs",
    //   value: "$2000",
    //   type: "Special",
    //   mapComponent: (
    //     <MapComponent
    //       startaddress={""}
    //       endaddress={""}
    //       position={{ start: [51.505, -0.09], end: [51.505, -0.09] }}
    //     />
    //   ),
    // },
    // {
    //   id: 2,
    //   pickups: 3,
    //   kms: 120,
    //   weight: "100 Lbs / 18 Kgs",
    //   value: "$1500",
    //   type: "Standard",
    //   mapComponent: (
    //     <MapComponent
    //       startaddress={""}
    //       endaddress={""}
    //       position={{ start: [51.505, -0.09], end: [51.505, -0.09] }}
    //     />
    //   ),
    // },
    // {
    //   id: 3,
    //   pickups: 5,
    //   kms: 160,
    //   weight: "140 Lbs / 22 Kgs",
    //   value: "$2500",
    //   type: "Urgent",
    //   mapComponent: (
    //     <MapComponent
    //       startaddress={""}
    //       endaddress={""}
    //       position={{ start: [51.505, -0.09], end: [51.505, -0.09] }}
    //     />
    //   ),
    // },
  ]);

  const { page, limit, setLimit, setPage, setTotal, total } = usePagination();
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(+event.target.value);
    setPage(0);
  };

  const [mergedSteps, setMergedSteps] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const location = useLocation();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const navigate = useNavigate();
  const handleViewAllClick = () => {
    navigate(`/services/orders?driverId=${driver.driverID}`);
  };
  const [driver, setDriver] = useState(location.state?.selectedDriver);
  const [driverEdit, setdriverEdit] = useState(false);
  const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
  const [insuranceDetails, setInsuranceDetails] = useState({
    name: "",
    coverageAmount: "",
    policyNumber: "",
    expiry: "",
  });

  const activeDeliveries = structuredClone(driver?.orders)?.filter((obj) => {
    return !["Completed", "Cancelled", "Delivered"].includes(
      obj.currentStatus.status ||
        obj.currentStatus[obj.currentStatus.length - 1].status,
    );
  });

  const currentOrder = activeDeliveries?.[page];

  const orderItems =
    activeDeliveries?.[page]?.orderItems.sort((a) =>
      a.type === "Pickup" ? -1 : 1,
    ) || [];

  useEffect(() => {
    async function fetchDriver() {
      const now = new Date();
      const startOfMonth = new Date(
        now.getFullYear(),
        now.getMonth(),
        1,
      ).toISOString();
      const endOfMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0,
        23,
        59,
        59,
        999,
      ).toISOString();
      const startOfToday = new Date(
        new Date().setHours(0, 0, 0, 0),
      ).toISOString();

      const endOfToday = new Date(
        new Date().setHours(23, 59, 59, 999),
      ).toISOString();
      try {
        const { data } = await $crud.retrieve("admin/driver", {
          driverID: driver.driverID,
          startOfMonth,
          endOfMonth,
          startOfToday,
          endOfToday,
        });
        setDriver({ ...location.state?.selectedDriver, ...data });
        setInsuranceDetails({
          name: data.insuranceDetails?.name || "",
          coverageAmount: data.insuranceDetails?.coverageAmount || "",
          policyNumber: data.insuranceDetails?.policyNumber || "",
          expiry: data.insuranceDetails?.expiry || "",
        });
      } catch (e) {
        console.error(e);
      }
    }
    fetchDriver();
  }, []);

  useEffect(() => {
    setDriver(location.state?.selectedDriver);
  }, [location.state]);

  useEffect(() => {
    // Combine order.positionHistory with existing steps
    const merged = [];

    if (driver && driver.blockStatusHistory) {
      driver.blockStatusHistory.forEach((historyItem, index) => {
        let label = "";
        let icon = "";
        let desc = "";
        let dot = "";
        <img src={dotIcon} />;

        const now = dayjs();

        const diffMs = now.diff(historyItem.updatedAt);
        const diffDuration = dayjs.duration(diffMs);

        const hours = Math.floor(diffDuration.asHours());
        const minutes = diffDuration.minutes();

        desc =
          toLocalTime(historyItem.updatedAt, "ddd,DD MMM YYYY,h:mm A ") +
          `${hours > 1 ? `${hours}hr` : `${minutes}mins`}`;

        icon = (
          <img
            src={statusIcon[historyItem.status] || minus}
            alt="status-icon"
            width="25px"
            style={{ marginLeft: "8px" }}
          />
        );

        merged.push({
          label: historyItem.status,
          description: desc,
          icon,
          reason: historyItem.reason,
          tooltip: true,
          dot,
        });
      });
    }

    setMergedSteps(merged);
  }, [driver]);
  const handleBackClick = () => {
    navigate(-1);
  };

  async function retrieveDriverOrders() {
    const { data } = await $crud.retrieve("admin/orders", {
      search: driver.driverID,
    });
    return data;
  }

  const sortedRows = useMemo(() => {
    let sortableRows = [...orderData];
    if (sortConfig.key !== null) {
      sortableRows.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableRows;
  }, [orderData, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    retrieveDriverOrders().then((res) => {
      setOrderData(res.result.slice(0, 5));
    });
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
  }, [driver]);

  const orderColumns = [
    {
      id: "orderId",
      label: "Order ID",
      align: "center",
    },
    {
      id: "dateBooked",
      label: "Date",
      align: "center",
      renderCell: (row) => toLocalTime(row.dateBooked),
    },
    {
      id: "status",
      label: "Status",
      align: "center",
      renderCell: (row) => {
        const style = getStatusStyles(row.currentStatus.status);
        return (
          <Button
            sx={{
              background: style.background,
              color: style.color,
              padding: "4px 14px",
              textTransform: "capitalize",
              border: "none",
              cursor: "default",
              fontSize: "10px",
              width: "90px",
              outline: "none !important",
            }}
          >
            {row.currentStatus.status}
          </Button>
        );
      },
    },
  ];

  // const orderData = [
  //   {
  //     orderID: "OID123",
  //     date: "27 May 2024, 12:00 AM",
  //     status: "New Order",
  //   },
  //   {
  //     orderID: "OID123",
  //     date: "27 May 2024, 12:00 AM",
  //     status: "New Order",
  //   },
  //   {
  //     orderID: "OID123",
  //     date: "27 May 2024, 12:00 AM",
  //     status: "New Order",
  //   },
  //   {
  //     orderID: "OID123",
  //     date: "27 May 2024, 12:00 AM",
  //     status: "New Order",
  //   },
  //   {
  //     orderID: "OID123",
  //     date: "27 May 2024, 12:00 AM",
  //     status: "New Order",
  //   },
  //   {
  //     orderID: "OID123",
  //     date: "27 May 2024, 12:00 AM",
  //     status: "New Order",
  //   },
  // ];

  useEffect(() => {
    socket.on("updateDriverOnlineStatus", (updatedDriver) => {
      setDriver((driver) => ({
        ...driver,
        onlineStatus: updatedDriver.status,
      }));
      enqueueSnackbar({
        message: `Driver ${updatedDriver.name} (${updatedDriver.driverID}) is now ${updatedDriver.status}`,
        variant: "info",
      });
    });

    return () => {
      socket.off("updateDriverOnlineStatus");
    };
  }, []);

  return (
    <Grid container sx={{ padding: "0 24px" }} spacing={1}>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <IconButton onClick={handleBackClick} sx={{ marginLeft: "-10px" }}>
            <img src={back} />
          </IconButton>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: 6,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "30px",
                  color: "#673C8E",
                }}
              >
                Driver's Details
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={6} sx={{ textAlign: "right" }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            padding: "6px 14px",
            textTransform: "capitalize",
            cursor: "default",
            borderRadius: 0,
            boxShadow: "none",
            fontWeight: 400,
            backgroundColor:
              driver.blockStatus === "Active"
                ? "rgba(103, 60, 142, 1)"
                : "rgba(255, 240, 237, 1)",
            color:
              driver.blockStatus === "Active"
                ? "#fff"
                : "rgba(254, 133, 106, 1)",
            "&:hover": {
              boxShadow: "none",
              backgroundColor:
                driver.blockStatus === "Active"
                  ? "rgba(103, 60, 142, 1)"
                  : "rgba(255, 240, 237, 1)",
              color:
                driver.blockStatus === "Active"
                  ? "#fff"
                  : "rgba(254, 133, 106, 1)",
            },
          }}
        >
          {/* Active */}
          {driver.blockStatus}
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            padding: "6px 65px",
            textTransform: "capitalize",
            backgroundColor:
              driver.onlineStatus === "Online"
                ? "rgba(7, 79, 36, 0.2)"
                : "rgba(255, 240, 237, 1)",
            color:
              driver.onlineStatus === "Online"
                ? "rgba(7, 79, 36, 1)"
                : "rgba(254, 133, 106, 1)",
            cursor: "default",
            boxShadow: "none",
            fontWeight: 400,
            "&:hover": {
              backgroundColor:
                driver.onlineStatus === "Online"
                  ? "rgba(7, 79, 36, 0.2)"
                  : "rgba(255, 240, 237, 1)",
              color:
                driver.onlineStatus === "Online"
                  ? "rgba(7, 79, 36, 1)"
                  : "rgba(254, 133, 106, 1)",
              boxShadow: "none",
            },
            mx: 2,
          }}
        >
          {/* Online */}
          {driver.onlineStatus}
        </Button>
      </Grid>

      <Grid item xs={12} mt={1} mb={1} mr={2}>
        <Grid container spacing={1}>
          <DriverDetailCard
            title="Today's Deliveries"
            heading={`${driver?.todaysDeliveries || 0} Orders`}
            subTitle="+150%vs past month"
          />
          <DriverDetailCard
            title="Monthly Deliveries"
            heading={`${driver?.monthlyDeliveries || 0} Orders`}
            subTitle="+150%vs past month"
          />
          <DriverDetailCard
            title="Delivery Issues"
            heading="0 Reported"
            subTitle="+150%vs past month"
          />
          <DriverDetailCard
            title="Total Deliveries"
            heading={`${driver?.deliveredorders || 0} Orders`}
            subTitle="+150%vs past month"
          />
        </Grid>
      </Grid>

      {/* DRIVER DETAIL CARD */}
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            borderRadius: "12px",
            padding: "15px",
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            gap: "16px",
            position: "relative",
            backgroundColor: "white",
          }}
        >
          <Box>
            <Avatar
              variant="square"
              sx={{ width: "170px", height: "165px" }}
              // src={profile}
              src={driver.profile}
            />
            <Typography mt={"5px"} textAlign={"center"}>
              {driver.driverID}
            </Typography>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Box
              display={"flex"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "20px",
                    color: "#000",
                    fontWeight: 600,
                  }}
                >
                  {driver.name}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#7E7E7E",
                  }}
                >
                  {driver.location || "NA"}
                </Typography>
              </Box>
              <IconButton
                onClick={() => setdriverEdit(true)}
                sx={{
                  position: "absolute",
                  right: "20px",
                  top: "18px",
                  background: "rgba(104, 60, 140, 0.35)",
                  borderRadius: 0,
                  "&:hover": {
                    background: "rgba(104, 60, 140, 0.35)",
                  },
                }}
              >
                <img src={edit} />
              </IconButton>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              mt={"20px"}
            >
              <Typography
                sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
              >
                Enrolled for sales Tax -{" "}
                <span style={{ fontWeight: 400 }}>
                  {driver.isEnrolledforsalesTax}
                </span>
              </Typography>
              <Typography
                sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
              >
                Enrollment date -{" "}
                <span style={{ fontWeight: 400 }}>
                  {toLocalTime(driver.enrollmentforTaxDate)}
                </span>
              </Typography>
            </Box>
            {driver.isEnrolledforsalesTax === "Yes" && (
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                mt={"10px"}
              >
                <Typography
                  sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
                >
                  Tax Name -{" "}
                  <span style={{ fontWeight: 400 }}>{driver.taxName}</span>
                </Typography>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "12px", color: "black" }}
                >
                  Tax ID -{" "}
                  <span style={{ fontWeight: 400 }}>{driver.taxID}</span>
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "end",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "space-between",
                  gap: 1,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <img src={email} />
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: "12px",
                      color: "rgba(23, 26, 31, 1)", // Return the value directly
                    }}
                  >
                    {driver.email}
                  </Typography>
                </Box>
                <Box display="flex" flexDirection={"column"} gap="10px">
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <img src={call} />
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: "12px",
                        color: "rgba(23, 26, 31, 1)", // Return the value directly
                      }}
                    >
                      {driver.phone}
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: "right" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000",
                      }}
                    >
                      Rating
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#683C8C",
                        fontWeight: 600,
                      }}
                    >
                      4.7 Points
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* DRIVER HISTORY STEPPER */}
      <Grid item xs={12} md={6} mt={2}>
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(104, 60, 140, 1)",
            fontWeight: 700,
            textAlign: "center",
            mb: 2,
          }}
        >
          Driver History
        </Typography>
        <Box
          sx={{
            border: "1px solid #673C8E",
            padding: "12px",
            marginTop: "12px",
            ml: 2,
            height: "auto",
            maxWidth: "100%",
            overflowX: "auto",
            marginRight: "14px",
          }}
        >
          <Stepper
            activeStep={3}
            orientation="horizontal"
            connector={<CustomStepConnector />}
          >
            {mergedSteps.map((step, index) => (
              <Step key={index} sx={{ minWidth: "120px", maxWidth: "150px" }}>
                {step.tooltip ? (
                  <CustomTooltip title={step.reason || "No reason provided"}>
                    <StepLabel
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      icon={step.icon}
                    >
                      <Typography
                        sx={{
                          textAlign: "center",
                          margin: "8px 0",
                        }}
                      >
                        {step.dot}
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(104, 60, 140, 1)",
                          fontSize: "10px",
                          fontWeight: 700,
                          textAlign: "center",
                        }}
                      >
                        {step.label}
                      </Typography>
                      <Typography
                        sx={{
                          color: "black",
                          fontSize: "10px",
                          textAlign: "center",
                        }}
                      >
                        {step.description}
                      </Typography>
                    </StepLabel>
                  </CustomTooltip>
                ) : (
                  <StepLabel
                    icon={step.icon}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        textAlign: "center",
                        margin: "8px 0",
                      }}
                    >
                      {step.dot}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(104, 60, 140, 1)",
                        fontSize: "10px",
                        fontWeight: 700,
                        textAlign: "center",
                      }}
                    >
                      {step.label}
                    </Typography>
                    <Typography
                      sx={{
                        color: "black",
                        fontSize: "10px",
                        textAlign: "center",
                      }}
                    >
                      {step.description}
                    </Typography>
                  </StepLabel>
                )}
              </Step>
            ))}
          </Stepper>
        </Box>
      </Grid>

      <Grid item xs={12} mt={2} mb={1}>
        <Card
          sx={{
            borderRadius: "12px",
            border: "1px solid rgba(103, 60, 142, 0.35)",
            padding: "16px 20px 18px",
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                color: "rgba(103, 60, 142, 1)",
                fontWeight: 700,
              }}
            >
              Insurance Details
            </Typography>
            <Button
              variant="contained"
              onClick={() => setInsuranceModalOpen(true)}
              sx={{
                borderRadius: "8px",
                background: "rgba(103, 60, 142, 1)",
                padding: "8px 22px",
                textTransform: "capitalize",
                fontWeight: 600,
                boxShadow: "none",
                width: "200px",
                color: "white",
                "&:hover": {
                  background: "rgba(103, 60, 142, 1)",
                  boxShadow: "none",
                },
              }}
            >
              Edit
            </Button>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
              gap: 3,
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#6B7280", mb: 0.5 }}>
                Name of Insurance
              </Typography>
              <Typography
                sx={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}
              >
                {driver?.insuranceDetails?.name || "NA"}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#6B7280", mb: 0.5 }}>
                Coverage Amt
              </Typography>
              <Typography
                sx={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}
              >
                {driver?.insuranceDetails?.coverageAmount
                  ? `$${formatMoney(driver?.insuranceDetails?.coverageAmount)}`
                  : "NA"}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#6B7280", mb: 0.5 }}>
                Policy Number
              </Typography>
              <Typography
                sx={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}
              >
                {driver?.insuranceDetails?.policyNumber || "NA"}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "12px", color: "#6B7280", mb: 0.5 }}>
                Expiry
              </Typography>
              <Typography
                sx={{ fontSize: "15px", fontWeight: 600, color: "#111827" }}
              >
                {driver?.insuranceDetails?.expiry
                  ? dayjs(new Date(driver?.insuranceDetails?.expiry)).format(
                      "DD MMM YYYY",
                    )
                  : "NA"}
              </Typography>
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* DRIVER PENDING CARD */}
      <Grid item xs={12} md={6} mt={1}>
        <Card sx={{ padding: "14px", borderRadius: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontSize: "13px",
                color: "#000",
                fontWeight: 400,
              }}
            >
              Pending $200
            </Typography>
            <Box sx={{ textAlign: "right" }}>
              {/* <Typography
                sx={{
                  fontSize: "14px",
                  color: "rgba(255, 129, 73, 1)",
                  fontWeight: 400,
                }}
              >
                Next Payout 2 Mar 2024
              </Typography> */}
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: 400,
                }}
              >
                Driving since : {toLocalTime(driver.joinDate)}
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontSize: "15px",
              color: "rgba(103, 60, 142, 1)",
              fontWeight: 400,
              margin: "10px 0",
            }}
          >
            Work Information
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: 400,
                }}
              >
                Total Hours
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "rgba(189, 193, 202, 1)",
                  fontWeight: 400,
                }}
              >
                1382
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: 400,
                }}
              >
                Avg.Monthly Online Hrs
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "rgba(189, 193, 202, 1)",
                  fontWeight: 400,
                }}
              >
                66
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: 400,
                }}
              >
                Total Paid till date
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "rgba(189, 193, 202, 1)",
                  fontWeight: 400,
                }}
              >
                {formatter.format(driver.totalPaidAmount)}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: 400,
                }}
              >
                Last Payment
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "rgba(189, 193, 202, 1)",
                  fontWeight: 400,
                }}
              >
                $1,233
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: 400,
                }}
              >
                Pending Payment
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px",
                  color: "rgba(189, 193, 202, 1)",
                  fontWeight: 400,
                }}
              >
                {formatter.format(driver.pending)}
              </Typography>
            </Box>
          </Box>
        </Card>

        {activeDeliveries?.length < 1 ? (
          <Card
            sx={{
              backgroundColor: "white",
              padding: "15px",
              borderRadius: "12px",
              mt: "10px",
              height: "246px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              display="flex"
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
                Driver Online Live Location
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#171A1F" }}>
                {driver.onlineStatus === "Online"
                  ? "Waiting:"
                  : "Last Online for"}{" "}
                {driver.lastOnlineTime
                  ? timeOnline(
                      driver.lastOnlineTime,
                      driver.onlineStatus === "Online"
                        ? new Date().toISOString()
                        : driver.lastOfflineTime,
                    )
                  : "NA"}
              </Typography>
            </Box>
            <Box
              sx={{ height: "100%" }}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Typography color="#7E7E7E" fontSize={"18px"} fontWeight={600}>
                Coming Soon
              </Typography>
            </Box>
          </Card>
        ) : (
          <Card sx={{ padding: "14px", borderRadius: 0, marginTop: "24px" }}>
            {activeDeliveries?.length < 1 ? (
              "No Orders"
            ) : (
              <>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#000",
                    fontWeight: 400,
                    textAlign: "center",
                  }}
                >
                  Current Deliveries
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#673C8E",
                    fontWeight: 400,
                  }}
                >
                  OID {currentOrder?.orderId}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 2,
                    mb: 2,
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#000",
                        fontWeight: 400,
                      }}
                    >
                      Total Pickups
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "rgba(189, 193, 202, 1)",
                        fontWeight: 400,
                      }}
                    >
                      {currentOrder?.totalPickups} pickups
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#000",
                        fontWeight: 400,
                      }}
                    >
                      Total Kms
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "rgba(189, 193, 202, 1)",
                        fontWeight: 400,
                      }}
                    >
                      {currentOrder?.totalDistance} Kms
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#000",
                        fontWeight: 400,
                      }}
                    >
                      Average weight
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "rgba(189, 193, 202, 1)",
                        fontWeight: 400,
                      }}
                    >
                      {currentOrder?.averageWeight?.toFixed(2)} Kgs
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#000",
                        fontWeight: 400,
                      }}
                    >
                      Total Value
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "rgba(189, 193, 202, 1)",
                        fontWeight: 400,
                      }}
                    >
                      {formatter.format(currentOrder?.amount)}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#000",
                        fontWeight: 400,
                      }}
                    >
                      VIP Order
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#FF8149",
                        fontWeight: 400,
                      }}
                    >
                      {currentOrder?.is_vip ? "Yes" : "No"}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    height: "113px",
                  }}
                >
                  <MapComponent
                    orderItems={currentOrder?.orderItems}
                    pickups={orderItems?.slice(0, orderItems?.length - 1)}
                    dropoff={orderItems?.slice(orderItems?.length - 1)}
                  />
                </Box>
              </>
            )}
          </Card>
        )}
        {activeDeliveries?.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <CustomPagination
              count={3}
              rowsPerPage={1}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              total={activeDeliveries?.length || 0}
              type="driverDetails"
            />
          </Box>
        )}
      </Grid>
      <Grid item xs={12} md={6} mt={1}>
        <Card sx={{ borderRadius: 0, marginRight: "14px", ml: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
              width: "100%",
              padding: "20px",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "22px",
                  color: "rgba(103, 60, 142, 1)",
                  fontWeight: 600,
                }}
              >
                Order Details
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "rgba(103, 60, 142, 1)",
                  fontWeight: 700,
                  cursor: "pointer",
                  textTransform: "uppercase",
                }}
                onClick={handleViewAllClick}
              >
                VIEW All
              </Typography>
            </Box>
          </Box>

          <TableContainer
            sx={{
              height: "350px",
              maxWidth: "100vw",
              // boxShadow: (theme) => theme.shadows[5],
              borderRadius: 0,
              position: "relative", // Ensure that the container is positioned relatively
            }}
          >
            <Table
              // size="small"
              // aria-label="a dense table"
              sx={{ borderRadius: "0", height: "100%" }}
              stickyHeader
              // aria-label=" sticky table"
            >
              <TableHead>
                <TableRow>
                  {orderColumns?.map((column) => (
                    <TableCell
                      sx={{
                        background: "#683C8C",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                      key={column.id}
                      align={column.align}
                      onClick={() => requestSort(column.id)}
                    >
                      {column.label}
                      {column.label != "Status" && (
                        <img
                          src={sort}
                          style={{
                            marginLeft: "10px",
                            width: "10px",
                            height: "10px",
                          }}
                        />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {sortedRows.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={orderColumns.length}
                      sx={{ borderBottom: "none", p: 0 }}
                    >
                      <Box
                        sx={{
                          height: "200px", // Ensure it matches the height of the container
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "16px", color: "rgba(0, 0, 0, 1)" }}
                        >
                          No orders
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {sortedRows?.map((row) => (
                    <TableRow
                      sx={{
                        cursor: "pointer",
                      }}
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.code}
                    >
                      {orderColumns?.map((column) => {
                        const value = row[column.id];

                        return (
                          <TableCell
                            sx={{
                              color: "rgba(86, 93, 109, 1)",
                              fontSize: "12px",
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            {column?.renderCell
                              ? column?.renderCell(row)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Card>
      </Grid>
      {driverEdit && (
        <DriverEditModal
          onClose={setdriverEdit}
          driver={driver}
          open={driverEdit}
          setDriver={setDriver}
        />
      )}

      {insuranceModalOpen && (
        <InsuranceDetailsModal
          open={insuranceModalOpen}
          onClose={() => setInsuranceModalOpen(false)}
          insuranceDetails={insuranceDetails}
          setInsuranceDetails={setInsuranceDetails}
          setInsuranceModalOpen={setInsuranceModalOpen}
          setDriver={setDriver}
          driver={driver}
        />
      )}
    </Grid>
  );
}
